import { useState, useEffect } from 'react'
import { getCostCenterSelectAPI } from '../services/more-dropdown'

function UseCostCenterSelect() {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const result = await getCostCenterSelectAPI()
      if (!result) return
      if (result.status) {
        const newData = result.result.map((d) => {
          return { value: d?.costId, label: d?.costName }
        })

        setData(newData)
      } else {
        setData([])
      }
    }
    getData()
  }, [])

  return data
}

export default UseCostCenterSelect
